/**
 * @generated SignedSource<<516e1784e73c75f8f676e510b853068b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "OTP" | "PUBLIC" | "RESTRICTED" | "TOKEN";
export type ZnglyVideoMediaNameEnum = "AUDIO" | "CSV" | "EMBED" | "IMAGE" | "LINK" | "MIXCLOUD" | "MP4" | "OTHER" | "PDF" | "SHAREPOINT" | "SOUNDCLOUD" | "SPOTIFY" | "SYNTHESIA" | "TED" | "UNDEFINED" | "VIMEO" | "YOUTUBE";
export type ZnglyVideoPostTypeEnum = "EMBED" | "EXTERNAL" | "FILE";
export type UpdateZnglyVideoInput = {
  aiSummary?: string | null | undefined;
  authorId?: string | null | undefined;
  categories?: ZnglyVideoCategoriesInput | null | undefined;
  clientMutationId?: string | null | undefined;
  content?: string | null | undefined;
  contentEmbedHtml?: string | null | undefined;
  contentFile?: string | null | undefined;
  contentLink?: string | null | undefined;
  contentMediaName?: ZnglyVideoMediaNameEnum | null | undefined;
  contentMediaType?: ZnglyVideoPostTypeEnum | null | undefined;
  ctaLink?: string | null | undefined;
  ctaName?: string | null | undefined;
  date?: string | null | undefined;
  excerpt?: string | null | undefined;
  featuredImageFile?: string | null | undefined;
  featuredImageLink?: string | null | undefined;
  formId?: string | null | undefined;
  htmlDesc?: string | null | undefined;
  id: string;
  ignoreEditLock?: boolean | null | undefined;
  menuOrder?: number | null | undefined;
  password?: string | null | undefined;
  shortText?: string | null | undefined;
  slug?: string | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusSettings?: StatusSettingsInput | null | undefined;
  tags?: ZnglyVideoTagsInput | null | undefined;
  title?: string | null | undefined;
  videoDuration?: string | null | undefined;
};
export type ZnglyVideoCategoriesInput = {
  append?: boolean | null | undefined;
  nodes?: ReadonlyArray<ZnglyVideoCategoriesNodeInput | null | undefined> | null | undefined;
};
export type ZnglyVideoCategoriesNodeInput = {
  description?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  slug?: string | null | undefined;
};
export type StatusSettingsInput = {
  approved?: ApprovedStateInput | null | undefined;
  stateWhenApproved?: StateWhenApprovedInput | null | undefined;
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type ApprovedStateInput = {
  id?: string | null | undefined;
};
export type StateWhenApprovedInput = {
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type UIPermissionInput = {
  token?: string | null | undefined;
  type?: StatusUiPermissionEnum | null | undefined;
};
export type ZnglyVideoTagsInput = {
  append?: boolean | null | undefined;
  nodes?: ReadonlyArray<ZnglyVideoTagsNodeInput | null | undefined> | null | undefined;
};
export type ZnglyVideoTagsNodeInput = {
  description?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  slug?: string | null | undefined;
};
export type Content_Update_Mutation$variables = {
  input: UpdateZnglyVideoInput;
};
export type Content_Update_Mutation$data = {
  readonly updateZnglyVideo: {
    readonly znglyVideo: {
      readonly author: {
        readonly node: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly slug: string | null | undefined;
          readonly username: string | null | undefined;
        };
      } | null | undefined;
      readonly categories: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
        }>;
      } | null | undefined;
      readonly databaseId: number;
      readonly id: string;
      readonly link: string | null | undefined;
      readonly status: string | null | undefined;
      readonly statusSettings: {
        readonly approved: {
          readonly id: string | null | undefined;
          readonly timestamp: string | null | undefined;
          readonly user: {
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly stateWhenApproved: {
          readonly status: PostStatusEnum | null | undefined;
          readonly uiPermission: {
            readonly token: string | null | undefined;
            readonly type: StatusUiPermissionEnum | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly status: PostStatusEnum | null | undefined;
        readonly uiPermission: {
          readonly token: string | null | undefined;
          readonly type: StatusUiPermissionEnum | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly tags: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        }>;
      } | null | undefined;
      readonly title: string | null | undefined;
      readonly znglyContent: {
        readonly aiSummary: string | null | undefined;
        readonly contentEmbedHtml: string | null | undefined;
        readonly contentFile: {
          readonly author: {
            readonly node: {
              readonly id: string;
              readonly name: string | null | undefined;
              readonly slug: string | null | undefined;
              readonly username: string | null | undefined;
            };
          } | null | undefined;
          readonly description: string | null | undefined;
          readonly fileSize: number | null | undefined;
          readonly id: string;
          readonly mediaDetails: {
            readonly sizes: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly sourceUrl: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly mediaItemUrl: string | null | undefined;
          readonly mimeType: string | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined;
        readonly contentLink: string | null | undefined;
        readonly contentMediaName: string | null | undefined;
        readonly contentMediaType: string | null | undefined;
        readonly ctaLink: string | null | undefined;
        readonly ctaName: string | null | undefined;
        readonly featuredImageFile: {
          readonly author: {
            readonly node: {
              readonly id: string;
              readonly name: string | null | undefined;
              readonly slug: string | null | undefined;
              readonly username: string | null | undefined;
            };
          } | null | undefined;
          readonly description: string | null | undefined;
          readonly fileSize: number | null | undefined;
          readonly id: string;
          readonly mediaDetails: {
            readonly sizes: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly sourceUrl: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly mediaItemUrl: string | null | undefined;
          readonly mimeType: string | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined;
        readonly featuredImageLink: string | null | undefined;
        readonly form: {
          readonly node: {
            readonly content: string | null | undefined;
            readonly id: string;
            readonly title: string;
          };
        } | null | undefined;
        readonly htmlDesc: string | null | undefined;
        readonly shortText: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Content_Update_Mutation = {
  response: Content_Update_Mutation$data;
  variables: Content_Update_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "StateWhenApproved",
  "kind": "LinkedField",
  "name": "stateWhenApproved",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "NodeWithAuthorToUserConnectionEdge",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mediaItemUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mimeType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaDetails",
    "kind": "LinkedField",
    "name": "mediaDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaSize",
        "kind": "LinkedField",
        "name": "sizes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileSize",
    "storageKey": null
  },
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "ZnglyVideo_Znglycontent",
  "kind": "LinkedField",
  "name": "znglyContent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aiSummary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentMediaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentMediaName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentEmbedHtml",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "htmlDesc",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaItem",
      "kind": "LinkedField",
      "name": "contentFile",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "featuredImageLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaItem",
      "kind": "LinkedField",
      "name": "featuredImageFile",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
      "kind": "LinkedField",
      "name": "form",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Form",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v15 = {
  "alias": null,
  "args": (v14/*: any*/),
  "concreteType": "ZnglyVideoToCategoryConnection",
  "kind": "LinkedField",
  "name": "categories",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "categories(first:100)"
},
v16 = [
  (v10/*: any*/),
  (v4/*: any*/)
],
v17 = {
  "alias": null,
  "args": (v14/*: any*/),
  "concreteType": "ZnglyVideoToTagConnection",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Tag",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": "tags(first:100)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Content_Update_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateZnglyVideoPayload",
        "kind": "LinkedField",
        "name": "updateZnglyVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyVideo",
            "kind": "LinkedField",
            "name": "znglyVideo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusSettings",
                "kind": "LinkedField",
                "name": "statusSettings",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ApprovedState",
                    "kind": "LinkedField",
                    "name": "approved",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Content_Update_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateZnglyVideoPayload",
        "kind": "LinkedField",
        "name": "updateZnglyVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyVideo",
            "kind": "LinkedField",
            "name": "znglyVideo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusSettings",
                "kind": "LinkedField",
                "name": "statusSettings",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ApprovedState",
                    "kind": "LinkedField",
                    "name": "approved",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v16/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d73c74436923738a52018c860028b94",
    "id": null,
    "metadata": {},
    "name": "Content_Update_Mutation",
    "operationKind": "mutation",
    "text": "mutation Content_Update_Mutation(\n  $input: UpdateZnglyVideoInput!\n) {\n  updateZnglyVideo(input: $input) {\n    znglyVideo {\n      title\n      databaseId\n      id\n      link\n      status\n      statusSettings {\n        status\n        uiPermission {\n          type\n          token\n        }\n        stateWhenApproved {\n          status\n          uiPermission {\n            type\n            token\n          }\n        }\n        approved {\n          id\n          timestamp\n          user {\n            name\n            id\n          }\n        }\n      }\n      znglyContent {\n        aiSummary\n        shortText\n        contentMediaType\n        contentMediaName\n        contentLink\n        contentEmbedHtml\n        htmlDesc\n        ctaName\n        ctaLink\n        contentFile {\n          id\n          mediaItemUrl\n          mimeType\n          mediaDetails {\n            sizes {\n              sourceUrl\n              name\n            }\n          }\n          description\n          title\n          fileSize\n          author {\n            node {\n              id\n              name\n              username\n              slug\n            }\n          }\n        }\n        featuredImageLink\n        featuredImageFile {\n          id\n          mediaItemUrl\n          mimeType\n          mediaDetails {\n            sizes {\n              sourceUrl\n              name\n            }\n          }\n          description\n          title\n          fileSize\n          author {\n            node {\n              id\n              name\n              username\n              slug\n            }\n          }\n        }\n        form {\n          node {\n            id\n            title\n            content\n          }\n        }\n      }\n      categories(first: 100) {\n        nodes {\n          id\n        }\n      }\n      tags(first: 100) {\n        nodes {\n          name\n          id\n        }\n      }\n      author {\n        node {\n          id\n          name\n          username\n          slug\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7c95c8a7cf74d908819c8520cdc00c3";

export default node;
